import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingScreen } from '../components/LoadingScreen';
import { useFeatureFlags } from '../hooks/useFeatureFlags';

/**
 * R-RESOCONTO: tenant finance settings (qualifiche, discipline, impostazioni economiche).
 * Requires FINANCE_ALERTS feature and AMMINISTRATORE_AZIENDA role.
 */
export function FinanceSettingsRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  const { hasFinanceAlerts } = useFeatureFlags();

  if (isLoading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (!hasFinanceAlerts || user.role !== 'AMMINISTRATORE_AZIENDA') {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
}
